import React from "react";

// Components
import Footer from "components/Footer/Footer";
import Service from "components/Service/Service/Service";

// Libraries & Packages
import { useParams } from "react-router-dom";
import Navigation from "utils/navigation/Navigation";

// Utils
import useContentfulData from "lib/Contentful/hooks/useContentfulData";

function ServicePage() {
  const { serviceID } = useParams();
  const serviceType = Navigation.getNameByTitle(serviceID);
  const contentfulData = useContentfulData("service", serviceType, {
    "fields.serviceType": serviceType,
  });

  return (
    <div>
      <Service serviceTitle={serviceType} serviceData={contentfulData} />
      <Footer />
    </div>
  );
}

export default ServicePage;
